<template>
  <div class="col-6 col-md-2 text-center" v-on="$listeners" v-bind="$attrs">
    <div class="card border-0 text-white HomeItem ">
      <div class="card-img-overlay d-flex justify-content-center align-items-center flex-column">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeItem',
  inheritAttrs: false
}
</script>
